import React from "react";

const MainContent = () => {
    return (
        <div className="w-2/3 bg-white p-4 rounded-lg shadow-md">
            <p className="text-gray-700 mb-4">
                Please note that every Friday at 5pm EST, all Schwab accounts will be automatically disconnected from JTNCBot...
            </p>
            <div className="flex justify-between items-center mb-4">
                <div>
                    <span className="font-semibold">Broker:</span>
                    <span className="text-green-600"> Connected</span>
                </div>
                <button className="bg-purple-500 text-white px-4 py-2 rounded">My Trade Log</button>
            </div>

            <div className="text-center mb-2">
                <h2 className="text-2xl font-bold">Results chart is under construction.</h2>
            </div>
            <div className="flex mb-4 justify-between">
                <select className="border rounded p-2">
                    <option>1 Month</option>
                </select>
                <select className="border rounded p-2">
                    <option>All</option>
                </select>
                <input
                    type="text"
                    placeholder="Search tickers"
                    className="border rounded p-2"
                />
            </div>
            <div className="flex justify-between">
                <div><span className="font-semibold">Realized P&L: $0</span></div>
                <div><span className="font-semibold">Total Trades: 0</span></div>
            </div>
            <div className="mt-4 text-sm text-gray-500">
                <p>
                    Reported results may not be complete or accurate. Please refer to your brokerage
                    account for exact trade details and edit your trade log accordingly.
                </p>
            </div>
        </div>
    );
};

export default MainContent;
